function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 34,
  height: 34,
  rx: 17,
  stroke: "#60FFDA",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3544 19.2925V24.6929C19.3544 24.8976 19.2532 25 19.0506 25H16.9747C16.7722 25 16.6709 24.8976 16.6709 24.6929V19.2925H11.3038C11.2194 19.2925 11.1435 19.2669 11.0759 19.2157C11.0253 19.1475 11 19.0707 11 18.9854V16.989C11 16.9037 11.0253 16.8355 11.0759 16.7843C11.1435 16.716 11.2194 16.6819 11.3038 16.6819H16.6709V11.3071C16.6709 11.2218 16.6962 11.1536 16.7468 11.1024C16.8143 11.0341 16.8903 11 16.9747 11H19.0506C19.135 11 19.2025 11.0341 19.2532 11.1024C19.3207 11.1536 19.3544 11.2218 19.3544 11.3071V16.6819H24.6962C24.8987 16.6819 25 16.7843 25 16.989V18.9854C25 19.1901 24.8987 19.2925 24.6962 19.2925H19.3544Z",
  fill: "#60FFDA"
});

function SvgButtonPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPlus);
export default __webpack_public_path__ + "static/media/button_plus.791235db.svg";
export { ForwardRef as ReactComponent };